import { render, staticRenderFns } from "./close.vue?vue&type=template&id=4bf2f0ec&scoped=true"
import script from "./close.vue?vue&type=script&lang=js"
export * from "./close.vue?vue&type=script&lang=js"
import style0 from "./close.vue?vue&type=style&index=0&id=4bf2f0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2f0ec",
  null
  
)

export default component.exports